



















import { Component, Prop, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import { PAYMENT_GATEWAYS } from "@/constants/payment"

@Component({
  computed: {
    ...mapState('Auth', {
      candidate: 'candidate'
    })
  },
})
export default class ServiceOrderCreatePaymentGateways extends Vue {
  @Prop() paymentGateway!: string

  paymentGateways = PAYMENT_GATEWAYS

}
